import { cn, mString } from 'lib/helpers/utility';

const AmountBadge = ({ amount, label, size = 'large' }) => {
  const isLarge = size === 'large';

  return (
    <div
      className={cn(
        'rounded-xl text-center',
        isLarge && 'bg-gradient-to-r from-success-50 to-success-100 px-8 py-3',
        !isLarge && 'border border-solid border-neutral-200 bg-white px-5 py-2'
      )}>
      {label && <p className="text-sm text-neutral-500">{label}</p>}
      <p
        className={cn(
          isLarge && 'text-3xl font-800 text-success-700',
          !isLarge && 'text-xl font-700 text-primary-900'
        )}>
        {mString(amount)}
      </p>
    </div>
  );
};

export default AmountBadge;
